import CancelIcon from '../../images/cancelIcon.svg'
import {
  Autocomplete,
  Box,
  Checkbox,
  Grid,
  InputAdornment,
  Popover,
  TextField,
  useMediaQuery
} from '@mui/material'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { makeStyles } from '@mui/styles'
import { width } from '@mui/system'
import React, { ChangeEvent, FC, useEffect, useState } from 'react'
import {
  flexcol,
  flexItemCenter,
  flexItemSpaceBetween,
  flexrow
} from '../../global'
import { copyObj } from '../../services/Helper'
import { Staff, StaffType } from '../../services/Types'
import { appTheme } from '../../theme'
import { ButtonCustom } from '../Button/ButtonCustom'
import HelpIcon from '../../images/Staff/HelpIcon.svg'
import {
  filterStaffSuggestions,
  formatStaffSuggestionLabel,
  useStaffSuggestions,
} from '../../hooks/useStaffSuggestions'

export interface ApproverProps {
  setTbdPresenters: any
  setTbdModerators: any
  setTbdSupportstaff: any
  eventData: any
  isRequired?: boolean
  title: string
  staff: Staff[]
  staff_type: StaffType
  onStaffChange: (staff: Staff[]) => void
  staffErrors?: number[]
  programOfficeId?: number | null
}

// css style
const useStyles = makeStyles({
  textField: {
    justifyContent: 'right',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '8px'
      }
    }
  },
  textField2: {
    marginLeft: '5px',
    marginRight: '15px',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '8px'
      }
    }
  },
  input: {
    background: '#ffffff'
  }
})
var isMobView = true
export const Approver: FC<ApproverProps> = ({
  title,
  staff_type,
  staff,
  onStaffChange,
  eventData,
  isRequired,
  setTbdPresenters,
  setTbdModerators,
  setTbdSupportstaff,
  staffErrors,
  programOfficeId
}) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  isMobView = useMediaQuery(appTheme.breakpoints.down('md'))
  const [formValues, setformValue] = useState<Staff[]>([])
  const [selectedFromSuggestion, setSelectedFromSuggestion] = useState<boolean[]>([])
  const suggestions = useStaffSuggestions(programOfficeId)

  useEffect(() => {
    setformValue(staff?.filter(s => s.staff_type === staff_type))
  }, [staff, staff_type])

  // Keep selectedFromSuggestion length in sync with formValues (handles external resets)
  useEffect(() => {
    setSelectedFromSuggestion(prev => {
      if (prev.length === formValues.length) return prev
      if (prev.length > formValues.length) return prev.slice(0, formValues.length)
      return [...prev, ...Array(formValues.length - prev.length).fill(false)]
    })
  }, [formValues.length])

  // useEffect(() => {
  //   if (title === 'Moderators' && staff.length === 0) {
  //     setformValue([
  //       {
  //         name: '',
  //         email: '',
  //         phone: '',
  //         programOffice: '',
  //         jobTitle: '',
  //         staff_type
  //       }
  //     ])
  //   }
  // }, [staff, staff_type, title])

  const handleFormChange = (
    idx: number,
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const values: Staff[] = copyObj(formValues)
    const name: 'name' | 'email' | 'phone' | 'programOffice' | 'jobTitle' = e
      .target.name as any
    values[idx][name] = e.target.value

    setformValue(values)
    onStaffChange(values)
  }

  let addFormFields = () => {
    setChecked(false)
    setSelectedFromSuggestion(prev => [...prev, false])
    setformValue([
      ...formValues,
      {
        name: '',
        email: '',
        phone: '',
        programOffice: '',
        jobTitle: '',
        staff_type
      }
    ])
  }

  let removeFormFields = (i: number) => {
    let newFormValues = [...formValues]
    newFormValues.splice(i, 1)
    onStaffChange(newFormValues)
    setSelectedFromSuggestion(prev => {
      const next = [...prev]
      next.splice(i, 1)
      return next
    })
  }
  let removeFormAllFields = () => {
    let newFormValues: Staff[] = []
    onStaffChange(newFormValues)
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  // Checkbox
  const [checked, setChecked] = React.useState(false)

  useEffect(() => {
    if (staff_type === StaffType.MODERATORS && checked === false) {
      setTbdModerators(0)
    }
    if (staff_type === StaffType.PRESENTERS && checked === false) {
      setTbdPresenters(0)
    }
    if (staff_type === StaffType.SUPPORT_STAFF && checked === false) {
      setTbdSupportstaff(0)
    }
  }, [checked])

  useEffect(() => {
    if (staff_type === StaffType.MODERATORS && eventData.tbd_moderators === 1) {
      setChecked(true)
    }
    if (staff_type === StaffType.PRESENTERS && eventData.tbd_presenters === 1) {
      setChecked(true)
    }
    if (
      staff_type === StaffType.SUPPORT_STAFF &&
      eventData.tbd_supportstaff === 1
    ) {
      setChecked(true)
    }

    setTbdPresenters(eventData.tbd_presenters)
    setTbdModerators(eventData.tbd_moderators)
    setTbdSupportstaff(eventData.tbd_supportstaff)
  }, [eventData])

  const handleChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) }
  }) => {
    setChecked(event.target.checked)
    // removeFormFields(0)
    removeFormAllFields()
    if (staff_type === StaffType.MODERATORS && event.target.checked === true) {
      setTbdModerators(1)
    }
    if (staff_type === StaffType.PRESENTERS && event.target.checked === true) {
      setTbdPresenters(1)
    }
    if (
      staff_type === StaffType.SUPPORT_STAFF &&
      event.target.checked === true
    ) {
      setTbdSupportstaff(1)
    }
    if (staff_type === StaffType.MODERATORS && event.target.checked === false) {
      setTbdModerators(0)
    }
    if (staff_type === StaffType.PRESENTERS && event.target.checked === false) {
      setTbdPresenters(0)
    }
    if (
      staff_type === StaffType.SUPPORT_STAFF &&
      event.target.checked === false
    ) {
      setTbdSupportstaff(0)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const getButtonText = (text: string) => {
    if (text.charAt(text.length - 1) === 's') {
      text = text.substring(0, text.length - 1)
    }
    return text
  }
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          py: '16px',
          pl: '20px',
          pr: '0px'
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '24px'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <Typography
              align='left'
              sx={{
                display: 'inline',
                fontSize: '20px',
                fontWeight: 500,
                lineHeight: '23.44px'
              }}
            >
              {title} <span style={{color:'red'}}>{isRequired && '*'}</span>
            </Typography>
            <IconButton
              aria-describedby={id}
              onClick={handleClick}
              sx={{
                display: 'inline',
                ml: '18px',
                width: '20px',
                height: '20px'
              }}
              style={flexItemCenter}
              color='inherit'
              size="large">
              <Box component='img' src={HelpIcon} alt={'HelpIcon'} />
            </IconButton>

            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
            >
              <Typography sx={{ maxWidth: 300 }}>
                {title === 'Presenters' &&
                  'Must enter the Presenter information before submitting your request.'}
              </Typography>
              <Typography sx={{ maxWidth: 300 }}>
                {title === 'Moderators' &&
                  'Must enter the DOL ETA Moderator information before submitting your request.'}
              </Typography>
              <Typography sx={{ maxWidth: 300 }}>
                {title === 'Support Staff' &&
                  'Enter the Support Staff information.'}
              </Typography>
            </Popover>
          </Box>

          <Box
            sx={{
              display: 'flex',
              float: 'right',
              flexDirection: {
                lg: 'row',
                md: 'row',
                sm: 'row',
                xs: 'column'
              },
              alignItems: 'center',
              gap: { lg: '4px', md: '4px', sm: '0px', xs: '0px' }
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '12px',
                mr: { xs: '10px' }
              }}
            >
              <Checkbox
                checked={checked}
                onChange={handleChange}
                size='small'
                style={{ color: '#565656', width: '24px', height: '24px' }}
              />
              <Typography
                sx={{
                  display: 'inline',
                  fontSize: '18px',
                  lineHeight: '30.6px',
                  fontWeight: '500'
                }}
              >
                TBD
              </Typography>
            </Box>
            {!isMobView && (
              <ButtonCustom
                width='175px'
                backgroundColor='#333333'
                color='#ffffff'
                label={`Add ${getButtonText(title)}`}
                onClick={() => addFormFields()}
              />
            )}
          </Box>
        </Box>

        {isMobView && (
          <ButtonCustom
            width='190px'
            backgroundColor='#333333'
            color='#ffffff'
            label={`Add ${getButtonText(title)}`}
            onClick={() => addFormFields()}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          pl: '20px',
          pr: '0px'
        }}
      >
        <Box>
          {formValues.map((element: Staff, index: number): any => (
            <Box
              key={index}
              sx={{
                background: 'rgba(244, 244, 244, 1)',
                borderRadius: '20px',
                pl: '32px',
                pr: '34px',
                py: '24px',
                mb: '20px'
              }}
            >
              <Box style={flexItemSpaceBetween}>
                <Typography fontSize='18px' fontWeight='500'>
                  {title}
                  {'  '}
                  {index + 1}
                </Typography>
                {/* <InputAdornment position='end'> */}
                <IconButton onClick={() => removeFormFields(index)} size="large">
                  <Box
                    sx={{ mr: '-2px' }}
                    component='img'
                    src={CancelIcon}
                    alt='CancelIcon'
                  />
                </IconButton>
                {/* </InputAdornment> */}
              </Box>

              <Box sx={{ ml: '-10px', mr: '15px' }}>
                <Autocomplete
                  freeSolo
                  disableClearable={!selectedFromSuggestion[index]}
                  options={suggestions}
                  getOptionLabel={formatStaffSuggestionLabel}
                  isOptionEqualToValue={(option, value) =>
                    typeof option !== 'string' &&
                    typeof value !== 'string' &&
                    option.email === value.email
                  }
                  filterOptions={(options, { inputValue }) =>
                    filterStaffSuggestions(options, inputValue)
                  }
                  inputValue={element.name}
                  onInputChange={(_, newInputValue, reason) => {
                    if (reason === 'input') {
                      const values: Staff[] = copyObj(formValues)
                      values[index].name = newInputValue
                      setformValue(values)
                      onStaffChange(values)
                      setSelectedFromSuggestion(prev => {
                        const next = [...prev]
                        next[index] = false
                        return next
                      })
                    }
                    // 'clear' and 'reset' are owned by onChange to avoid double-update
                  }}
                  onChange={(_, newValue) => {
                    if (newValue && typeof newValue !== 'string') {
                      // Suggestion selected — fill all fields
                      const values: Staff[] = copyObj(formValues)
                      values[index] = {
                        ...values[index],
                        name: newValue.name,
                        email: newValue.email,
                        phone: newValue.phone,
                        programOffice: newValue.programOffice,
                        jobTitle: newValue.jobTitle,
                      }
                      setformValue(values)
                      onStaffChange(values)
                      setSelectedFromSuggestion(prev => {
                        const next = [...prev]
                        next[index] = true
                        return next
                      })
                    } else if (typeof newValue === 'string') {
                      // freeSolo: user pressed Enter with a typed value
                      const values: Staff[] = copyObj(formValues)
                      values[index].name = newValue
                      setformValue(values)
                      onStaffChange(values)
                      setSelectedFromSuggestion(prev => {
                        const next = [...prev]
                        next[index] = false
                        return next
                      })
                    } else {
                      // null — X (clear) button clicked
                      const values: Staff[] = copyObj(formValues)
                      if (selectedFromSuggestion[index]) {
                        // Clear all suggestion-filled fields
                        values[index] = {
                          ...values[index],
                          name: '',
                          email: '',
                          phone: '',
                          programOffice: '',
                          jobTitle: '',
                        }
                      } else {
                        values[index].name = ''
                      }
                      setformValue(values)
                      onStaffChange(values)
                      setSelectedFromSuggestion(prev => {
                        const next = [...prev]
                        next[index] = false
                        return next
                      })
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='name'
                      label={`${title} ${index + 1} Full Name`}
                      size='small'
                      inputProps={{ ...params.inputProps, maxLength: 100 }}
                      InputProps={{ ...params.InputProps, className: classes.input }}
                      error={
                        !!(staffErrors?.includes(index) && !element.name.trim())
                      }
                      helperText={
                        staffErrors?.includes(index) &&
                        !element.name.trim() &&
                        'Firstname is required'
                      }
                      classes={{ root: classes.textField }}
                      sx={{
                        '.MuiOutlinedInput-root.Mui-focused': {
                          fieldset: { borderColor: '#006BD7' }
                        }
                      }}
                    />
                  )}
                />
              </Box>
              <Box className={classes.textField2}>
                <TextField
                  name='email'
                  label={`${title} ${index + 1} Email`}
                  multiline
                  value={element.email}
                  onChange={e => handleFormChange(index, e)}
                  fullWidth
                  size='small'
                  InputProps={{
                    className: classes.input
                  }}
                  inputProps={{ maxLength: 200 }}
                  error={
                    !!(
                      staffErrors?.includes(index) &&
                      (!element.email.trim() ||
                        !new RegExp(/\S+@\S+\.\S+/).test(element.email))
                    )
                  }
                  helperText={
                    staffErrors?.includes(index) &&
                    ((!element.email.trim() && 'Email is required') ||
                      (!new RegExp(/\S+@\S+\.\S+/).test(element.email) &&
                        'Incorrect email format'))
                  }
                  sx={{
                    '.MuiOutlinedInput-root.Mui-focused': {
                      fieldset: { borderColor: '#006BD7' }
                    }
                  }}
                />
              </Box>
              <Box className={classes.textField2}>
                <TextField
                  name='phone'
                  label={`${title} ${index + 1} Phone Number`}
                  multiline
                  value={element.phone}
                  onChange={e => handleFormChange(index, e)}
                  fullWidth
                  size='small'
                  InputProps={{
                    className: classes.input
                  }}
                  inputProps={{ maxLength: 200 }}
                  error={
                    !!(
                      staffErrors?.includes(index) && element.phone.trim() &&
                      (!new RegExp(/^\d+$/).test(element.phone) ||
                        element.phone.length !== 10)
                    )
                  }
                  helperText={
                    staffErrors?.includes(index) && element.phone.trim() &&
                    (
                      (!new RegExp(/^\d+$/).test(element.phone) && 'Incorrect phone number format') ||
                      (element.phone.length !== 10 && 'Phone number must be of 10 digits')
                    )
                  }
                  sx={{
                    '.MuiOutlinedInput-root.Mui-focused': {
                      fieldset: { borderColor: '#006BD7' }
                    }
                  }}
                />
              </Box>
              <Box className={classes.textField2}>
                <TextField
                  name='programOffice'
                  label={`${title} ${index + 1} Organization/Program Office`}
                  multiline
                  value={element.programOffice}
                  onChange={e => handleFormChange(index, e)}
                  fullWidth
                  size='small'
                  InputProps={{
                    className: classes.input
                  }}
                  error={
                    !!(
                      staffErrors?.includes(index) &&
                      !element.programOffice.trim()
                    )
                  }
                  helperText={
                    staffErrors?.includes(index) &&
                    !element.programOffice.trim() &&
                    'Organization/Program Office is required'
                  }
                  sx={{
                    '.MuiOutlinedInput-root.Mui-focused': {
                      fieldset: { borderColor: '#006BD7' }
                    }
                  }}
                />
              </Box>
              <Box className={classes.textField2}>
                <TextField
                  name='jobTitle'
                  label={`${title} ${index + 1} Job Title`}
                  multiline
                  value={element.jobTitle}
                  onChange={e => handleFormChange(index, e)}
                  fullWidth
                  size='small'
                  InputProps={{
                    className: classes.input
                  }}
                  error={
                    !!(staffErrors?.includes(index) && !element.jobTitle.trim())
                  }
                  helperText={
                    staffErrors?.includes(index) &&
                    !element.jobTitle.trim() &&
                    'Job Title is required'
                  }
                  sx={{
                    '.MuiOutlinedInput-root.Mui-focused': {
                      fieldset: { borderColor: '#006BD7' }
                    }
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Grid>
    </Grid>
  );
}
